import { useSelector } from 'react-redux';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';

import RouteNames from '@/router/routes';

import s from './rubricator.module.css';

const SUBPARENT_LINK = {
  'vps-manual': RouteNames.VPS_MANUAL,
  guide: RouteNames.GUIDE,
  'monitoring-manual': RouteNames.MONITORING_MANUAL,
  courses: RouteNames.COURSES,
  resale: RouteNames.RESALE,
  rating: RouteNames.RATING,
  glossary: RouteNames.GLOSSARY,
  monitoring: RouteNames.MONITORING,
};

function Rubricator({
  single = '',
  parent = '',
  subparent = '',
  subsubparent = '',
  child = '',
}) {
  const i18n = useSelector(appSelectors.translation);

  const SUBPARENT_NAME = {
    'vps-manual': i18n.инструкции,
    guide: i18n.справочник,
    'monitoring-manual': i18n.инструкции,
    courses: i18n.курсы,
    resale: i18n.Реселлинг,
    rating: i18n.рейтинг_брокеров,
    glossary: i18n.глоссарий,
    monitoring: i18n.онлайн_мониторинг,
  };
  return (
    <p className={s.rubricator}>
      {single && (
        <>
          <span className={s.accent_1}>[</span>
          <span className={s.base_3}>&#160;{single}&#160;</span>
          <span className={s.accent_1}>]</span>
        </>
      )}
      {parent && parent === 'main' && (
        <Link to="/" className={s.base_3}>
          [ {i18n.главная} ]
        </Link>
      )}
      {subparent && (
        <>
          <span className={s.accent_1}>&#160;•&#160;</span>
          <Link to={`/${SUBPARENT_LINK[subparent]}`} className={s.base_3}>
            [ {SUBPARENT_NAME[subparent]} ]
          </Link>
        </>
      )}
      {subsubparent && (
        <>
          <span className={s.accent_1}>&#160;•&#160;</span>
          <span className={s.base_3}>[ {subsubparent} ]</span>
        </>
      )}
      {child && (
        <>
          <span className={s.accent_1}>&#160;• [</span>{' '}
          <span className={s.accent_2}>&#160;{child}&#160;</span>{' '}
          <span className={s.accent_1}>]</span>
        </>
      )}
    </p>
  );
}

export default Rubricator;

Rubricator.propTypes = {
  single: PropTypes.string,
  subparent: PropTypes.string,
  subsubparent: PropTypes.string,
  parent: PropTypes.string,
  child: PropTypes.string,
};
